import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ExternalAssistantEmbedTheme,
  parseEmbedOptionsFromSearchParams
} from 'src/embed-shared/external-assistant-embed-options';
import { CommonService } from 'src/app/services/common/common.service';

/**
 * Shown by {@link ExternalAssistantGuard} when the external token API fails, so the embed
 * explains the problem in the host site's theme instead of rendering an empty assistant.
 */
@Component({
    selector: 'xa-external-assistant-access-denied',
    templateUrl: './external-assistant-access-denied.component.html',
    styleUrls: ['./external-assistant-access-denied.component.scss'],
    standalone: false
})
export class ExternalAssistantAccessDeniedComponent implements OnInit {
  public theme!: ExternalAssistantEmbedTheme;
  public readonly avatarUrl = '/assets/img/ai-chat-bot-new.png';

  /**
   * @param route Embed query (theme)
   * @param commonService Dismisses the bootstrap splash on this public page
   */
  constructor(
    private readonly route: ActivatedRoute,
    private readonly commonService: CommonService
  ) {}

  /**
   * Reads the embed theme from the query so the page matches the host site.
   */
  ngOnInit(): void {
    this.commonService.dismissBootstrapLoader();
    this.theme = parseEmbedOptionsFromSearchParams(new URLSearchParams(this.route.snapshot.queryParams)).theme;
  }
}
